import TourHost from './components/tour/TourHost';
// Import the component file, not the dashboard domain barrel, so packs that
// only render the nav do not pull in DashboardPage.
import { ActivityBell } from '../domains/dashboard/components/ActivityBell';

/**
 * Components emitted by the shared application layout, so every pack reachable
 * from that layout must register them.
 *
 * ReactOnRails iterates mounts in document order and rethrows on the first
 * unregistered component, which blanks every component after it — so a missed
 * registration here is not a local failure. Spread this object into each
 * pack's register call rather than importing the components one by one.
 *
 * ActivityBell is rendered by layouts/_nav_new.html.erb when the dashboard
 * feed flag is on.
 */
export const globalComponents = { TourHost, ActivityBell };

export default globalComponents;
